import { CompanyQuery } from "@generated/graphql";
import { LoadingButtonProps } from "@mui/lab";
import { Button, Tooltip } from "@mui/material";
import { COMPANY_STATUS_TITLE } from "constants/company";
import { CompanyContext } from "context/companyContext";
import { useContext } from "react";

export interface ButtonWithPermissionsProps extends LoadingButtonProps {
  tooltipText?: string;
  buttonText: string;
}

export const generateUnavailableText = (
  isCreateAvailable: boolean,
  currentCompany: CompanyQuery["company"] | undefined,
  entityTitle: string
) =>
  !isCreateAvailable && currentCompany?.status
    ? `Функционал ${entityTitle} недоступен, 
    так как компания находится в статусе 
    ${COMPANY_STATUS_TITLE[currentCompany?.status]}`
    : "";

const ButtonWithPermissions = ({ tooltipText, buttonText, sx, disabled, ...rest }: ButtonWithPermissionsProps) => {
  const { isCreateAvailable } = useContext(CompanyContext);

  return (
    <Tooltip title={tooltipText}>
      {/* для отображения тултипа на задизебленной кнопке */}
      <span>
        <Button
          sx={{
            whiteSpace: "nowrap",
            ...sx,
            "&.Mui-disabled": {
              pointerEvents: typeof isCreateAvailable === "undefined" || isCreateAvailable ? "none" : "auto",
            },
          }}
          variant='contained'
          color='primary'
          disabled={!isCreateAvailable || disabled}
          {...rest}>
          {buttonText}
        </Button>
      </span>
    </Tooltip>
  );
};

export default ButtonWithPermissions;
